import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./components/Login";
import Profile from "./pages/Profile";
import Parametrizacao from "./pages/Parametrizacao";
import LancamentoIndicadores from "./pages/LancamentoIndicadores";
import IndicadoresPage from "./pages/IndicadoresPage";
import Dashboard from "./pages/Dashboard";
import Auditoria from "./pages/Auditoria";
import Exportar from "./pages/Exportar";
import DadosConsolidados from "./pages/DadosConsolidados";
import ResetSenha from "./pages/ResetSenha";

import UserManagement from "./pages/UserManagement";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-senha" element={<ResetSenha />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="/usuarios" element={<UserManagement />} />
            <Route path="/parametrizacao" element={<Parametrizacao />} />

            <Route path="/indicadores" element={<IndicadoresPage />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="lancamento" element={<LancamentoIndicadores />} />
              <Route path="auditoria" element={<Auditoria />} />
              <Route path="exportar" element={<Exportar />} />
              <Route path="consolidados" element={<DadosConsolidados />} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
